module.exports = __webpack_public_path__ + "static/Glober_Regular-5c7d02c1fa8e1a2233c1520d815a97aa.eot";